import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
export const getDropdownData = async () => {
  const dropdown = await Promise.all([
    dropdownMapping(
      endpoint.academic_career.getAllActive,
      "academicCareerDispValue",
      "id"
    ),
  ]);
  return {
    academicCareer: dropdown[0],
  };
};

export const viewTextStyle = {
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0%',
  textDecorationLine: 'underline',
  textDecorationStyle: 'solid',
  textDecorationColor: 'currentColor', // Optional: specify a color
  textDecorationThickness: '0%',
  textDecorationOffset: '0%',
};


export const getCreateReqBody = (rowData, selectedCategory) => {
  return {
    ...rowData,
    subSubCategoryId: selectedCategory?.id,
    dateControl: rowData?.dateControl?.label,
    academicCareerIds: rowData?.academicCareer
      ?.map((item) => item?.value)
      .join(","),
  };
};
export const newRow = {
  subSubCategoryId: "",
  noOfDays: "",
  dateControl: "",
  ticketId: "",
  status: "ACTIVE",
  academicCareerIds: "",
  status: "ACTIVE",
};

export const formatTribyteAccess = (val) => {
  return val.map((item) => item?.label).join(", ");
};

export const dateControlDropdown = [
  {
    label: "Date of Charge Finalization",
    value: "Date of Charge Finalization",
  },
  { label: "Date of Registration", value: "Date of Registration" },
];

export const getSubSubCategory = (subCategories = [], subSubCategoryId) => {
  if (!subSubCategoryId || subCategories?.length === 0) return {};

  return subCategories.find((item) => item?.id === subSubCategoryId);
};

export const getSubSubCategoryList = (treeList) => {
  if (treeList?.length === 0) return [];
  return treeList
    .filter((item) => item?.categoryCode === "C")
    .map((subCategory) => subCategory?.subCategories)
    .flat()
    .map((subSubCat) => subSubCat?.subSubCategory)
    .flat();
};


export const getAcdCarrierList = (dropdown, ids) => {
  if (!dropdown?.length || !ids) return [];
  const idsList = ids.split(",") || [];
  return dropdown.filter((item) => idsList?.includes(item?.value?.toString()));
};


export  const getAcdLabelValue =(list)=>{
   if(!list.length) return "-"
 return  list?.map(item=>item?.label)?.join(",")
}